export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAOsJ7fTwbsfv1_e7nhJDw458-3Z54cZ-E",
    authDomain: "adatest-909a2.firebaseapp.com",
    projectId: "adatest-909a2",
    storageBucket: "adatest-909a2.firebasestorage.app",
    databaseURL: "https://adatest-909a2-default-rtdb.europe-west1.firebasedatabase.app",
    messagingSenderId: "30182476473",
    appId: "1:30182476473:web:cfb6809ef3cd530a8b2968",
  },
};
